import React, { useEffect } from 'react';
import './index.css';

const t = (props: any) => {
  useEffect(() => { }, []);

  return (
    <h3 className="tag-t" id={props.id} data-tag={props.tag} data-st={props.st} data-et={props.et}>
      {props.children}
    </h3>
  );
};

export default t;
